import { featuresIcons } from 'Client/cms/toolkit/product-utils/productFeatures.icons';
import { ICONS } from 'Components/utils/icon/icons';
import { LAYER_NAME_UPSELL_ACTIVITIES } from 'Components/utils/layers/layers.constants';
import { partition } from 'lodash';
export const getHowToBookI18n = ({
  hasBookingOnline,
  hasBookingOnsite,
}: {
  hasBookingOnline: boolean;
  hasBookingOnsite: boolean;
}): string => {
  if (!hasBookingOnline && !hasBookingOnsite) {
    return '';
  }

  if (hasBookingOnline && hasBookingOnsite) {
    return 'common.bookOnlineOrOnsite';
  }

  return hasBookingOnline ? 'common.bookOnlineOnly' : 'common.bookOnsiteOnly';
};
export const getParticpantsI18n = (participants: ActivityParticipants) => {
  const { max, min } = participants || {};
  const hasMinValue = min && min > 0;
  const hasMaxValue = max && max > 0;

  if (hasMinValue && hasMaxValue) {
    return 'common.groupRange';
  }

  if (hasMaxValue) {
    return 'common.groupMax';
  }

  if (hasMinValue) {
    return 'common.groupMin';
  }

  return '';
};
export const flatActivities = (
  acc: Array<ActivityEntity>,
  cat: ActivitiesCategoryEntity,
): Array<ActivityEntity> => {
  const a = [...acc, ...(cat.activities || [])];

  if (cat.categories?.length) {
    return cat.categories.reduce(flatActivities, a);
  }

  return a;
};
export const flatFacilities = (
  acc: Array<FacilityEntity>,
  cat: ActivitiesCategoryEntity,
): Array<FacilityEntity> => {
  const a = [...acc, ...(cat.facilities || [])];

  if (cat.categories?.length) {
    return cat.categories.reduce(flatFacilities, a);
  }

  return a;
};
export const filterActivities = (isIncluded: boolean) => (a: ActivityEntity) =>
  a.isIncluded === isIncluded;
export const getActivitiesCategoryIcon = (
  keywords: Array<string> | undefined,
  id: ActivitiesCategoryId,
) => {
  if (keywords?.length) {
    const keyword = keywords.find((k) => featuresIcons.hasOwnProperty(k));
    return keyword ? featuresIcons[keyword]?.icon : ICONS.TRIDENT1;
  }

  switch (id) {
    case 'AC_Wellness':
      return ICONS.WELL_BEING;

    case 'AC_excursions':
      return ICONS.CULTURE_DISCOVERY;

    default:
      return ICONS.TRIDENT1;
  }
};
export const getUpsellCmsKeyPath = (upsellType: ServiceType | null | undefined) => {
  switch (upsellType) {
    case 'LAND_SPORT':
    case 'WATER_SPORT':
    case 'WINTER_SPORT':
      return 'sportActivities';

    case 'RENTAL':
      return 'skiEquipment';

    case 'EXCURSION':
      return 'excursions';

    case 'WELLNESS':
      return 'wellness';

    case 'CHILDCARE':
      return 'childcare';

    default:
      return '';
  }
};
export const getActivitiesLayerName = (bookingId: string, stayId: string) =>
  `${LAYER_NAME_UPSELL_ACTIVITIES}_${bookingId}_${stayId}`;
export const sortCategoryOnDemandActivitiesByStartingPrice = (categoryOnDemandActivities: any) => {
  const [onlineCategoryOnDemandActivities, checkPriceInResortCategoryOnDemandActivities] =
    partition(
      categoryOnDemandActivities,
      ({ additionalService }) => additionalService?.pricingInfo?.startingPricePerAdult?.value,
    );
  const [checkPriceInResortWithPrice, checkPriceInResortWithoutPrice] = partition(
    checkPriceInResortCategoryOnDemandActivities,
    ({ price }) => price?.value,
  );
  const onlineCategoryOnDemandActivitiesSorted = [
    ...onlineCategoryOnDemandActivities.sort(
      (a, b) =>
        a.additionalService.pricingInfo.startingPricePerAdult.value -
        b.additionalService.pricingInfo.startingPricePerAdult.value,
    ),
    ...checkPriceInResortWithPrice.sort((a, b) => (a?.price?.value || 0) - (b?.price?.value || 0)),
    ...checkPriceInResortWithoutPrice,
  ];
  return onlineCategoryOnDemandActivitiesSorted;
};
